<template>
    <div>
        <!--    Desktop header  -->
        <div class="hidden lg:block">
            <k-container size="lg" background="bg-white">
                <nav class="py-4">
                    <div class="flex items-center flex-wrap" style="min-height: 29px;">
                        <div class="flex-grow mr-4">
                            <router-link to="/">
                                <img src="/img/kilde_logo.png" style="max-width: 88px;">
                            </router-link>
                        </div>
                        <div class="font-base leading-tight flex flex-row">
                            <img src="/img/user.svg" class="self-center pr-2 h-6 cursor-pointer"
                                 @click="navigateTo('/settings')">
                            <div
                                class="text-xs inline-block self-center whitespace-no-wrap px-2 truncate cursor-pointer"
                                @click="navigateTo('/settings')"
                                style="max-width: 250px;">
                                <div class="font-semibold">
                                    {{ $root.$data.investorProfile.firstName }}
                                    {{ $root.$data.investorProfile.lastName }}
                                </div>
                                <div>(Account No.{{ $root.$data.investorProfile.number }})</div>
                            </div>
                            <div class="inline-block self-center whitespace-no-wrap px-2 truncate cursor-pointer">
                                <template v-for="account in $root.$data.investorProfile.accounts">
                                    <div class="font-semibold text-primary-500 self-center whitespace-no-wrap px-2"
                                         v-if="account.balance > 0" :key="account.currencyCode">
                                        {{ account.balance | currencyFormat(account.currencySymbol) }}
                                    </div>
                                </template>
                            </div>
                            <router-link class="block self-center pl-4" :to="'logout'">
                                <img src="/img/logout.svg" class="inline">
                            </router-link>
                        </div>
                    </div>
                </nav>
            </k-container>
            <k-container size="lg" background="bg-primary-500"
                         :class="[attach ? 'fixed w-full top-0 z-10 shadow-md': 'relative']">
                <div class="text-sm font-bold text-white leading-tight flex py-2">
                    <template v-for="(item, index) in availableRoutes">
                        <router-link
                            class="block self-center whitespace-no-wrap hover:text-black p-2 rounded relative mx-2"
                            :class="[index === 0 ? 'ml-0' : '', items.length - 1 === index ? 'mr-0' : '']"
                            exact
                            :to="item.href"
                            :key="item.title">
                            {{ item.title }}
                        </router-link>
                    </template>
                </div>
            </k-container>
            <div class="desktop-header-placeholder" :style="{'height': attach ? '49px': '0'}"></div>
        </div>

        <!--    Mobile header   -->
        <div class="lg:hidden">
            <div class="fixed w-full top-0 z-10 shadow-sm">
                <k-container size="lg" background="bg-white">
                    <nav class="pt-4 pb-2">
                        <div class="flex items-center flex-wrap">
                            <div class="flex-grow mr-4">
                                <router-link to="/">
                                    <img src="/img/kilde_logo.png" style="max-width: 88px;">
                                </router-link>
                            </div>
                            <button class="flex items-center px-3 py-2 border rounded text-gray-800 border-gray-800"
                                    v-on:click="toggleMenu()">
                                <svg class="fill-current h-4 w-4" viewBox="0 0 20 20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <title>
                                        Menu</title>
                                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
                                </svg>
                            </button>
                        </div>
                        <div class="font-base flex flex-wrap justify-between w-full mt-3">
                            <div class="text-xs inline-block self-center whitespace-no-wrap truncate font-semibold">
                                {{ $root.$data.investorProfile.firstName }} {{ $root.$data.investorProfile.lastName }}
                            </div>
                            <span class="text-xs inline-block self-center whitespace-no-wrap">
                                Account No.{{ $root.$data.investorProfile.number }}
                            </span>
                        </div>
                    </nav>
                </k-container>
                <k-container size="lg" background="bg-primary-500" v-if="itemsVisible">
                    <div class="text-sm font-bold text-white leading-tight flex-col w-full py-2">
                        <template v-for="(item) in availableRoutes">
                            <router-link
                                class="block self-center whitespace-no-wrap hover:text-black p-2 rounded relative"
                                exact
                                :to="item.href"
                                :key="item.title">
                                {{ item.title }}
                            </router-link>
                        </template>
                        <router-link class="block whitespace-no-wrap hover:text-black p-2 relative"
                                     :to="'logout'">
                            Logout <img src="/img/logout-white.svg" class="inline h-5 ml-2">
                        </router-link>
                    </div>
                </k-container>
            </div>
            <div class="mobile-header-placeholder"></div>
        </div>
        <div data-tf-popover="rSEPG1V2" data-tf-opacity="100" data-tf-iframe-props="title=Kilde Customer Support Chat"
             data-tf-transitive-search-params data-tf-button-color="#0445AF" data-tf-medium="snippet"
             :data-tf-hidden="`email=${$root.$data.investorProfile.email},investor_number=${$root.$data.investorProfile.number}`"
             style="all:unset;"></div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            itemsVisible: false,
            items: [
                {title: 'Dashboard', href: '/dashboard', activeInvestorNeeded: false},
                {title: 'Invest', href: '/tranche-listing', activeInvestorNeeded: false},
                // {title: 'Borrowers', href: '/borrowers', activeInvestorNeeded: true},
                {title: 'Autoinvestment', href: '/autoinvestment', activeInvestorNeeded: false},
                {title: 'Account statement', href: '/account-statement', activeInvestorNeeded: false},
                {title: 'Wallet', href: '/wallet', activeInvestorNeeded: false},
                {title: 'Settings', href: '/settings', activeInvestorNeeded: false}
            ],
            currentScrollPosition: 0,
            attach: false
        }
    },
    methods: {
        toggleMenu() {
            this.itemsVisible = !this.itemsVisible
        },
        handleScroll() {
            this.currentScrollPosition = window.pageYOffset;
            this.attachAtOffset(61);
        },
        attachAtOffset(offset) {
            if (this.currentScrollPosition >= offset) {
                this.attach = true;
                return;
            }
            this.attach = false;
        },
        navigateTo(path) {
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        }
    },
    computed: {
        availableRoutes() {
            if (this.$root.$data.investorProfile.active) {
                return this.items;
            } else {
                return _.filter(this.items, {activeInvestorNeeded: false});
            }
        },
        tfHiddenFields() {
            return `email=${this.$root.$data.investorProfile.email}`
        }

    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.$scriptLoader.loadScript('https://embed.typeform.com/next/embed.js');
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
.router-link-exact-active, .router-link-active {
    color: black;
    background-color: #ffffff;
}

.mobile-header-placeholder {
    height: 66px;
}
</style>

